// extracted by mini-css-extract-plugin
export default {"travelContacts":"TravelContacts_travelContacts__VAc3g","contactsButton":"TravelContacts_contactsButton__JzzKK","contactsText":"TravelContacts_contactsText__SNFoP"};